import { rolesID } from '../constants/rolesID';
import { ROUTES } from '../constants/routes';

import { ReactComponent as PartnersIcon } from '../assets/images/partners.svg';
import { ReactComponent as BonusesIcon } from '../assets/images/bonuses.svg';
import { ReactComponent as TeamIcon } from '../assets/images/team.svg';
import { ReactComponent as SupportIcon } from '../assets/images/support.svg';
import { ReactComponent as SettingIcon } from '../assets/images/permissions.svg';
import { ReactComponent as MailingIcon } from '../assets/images/mailing.svg';
import { ReactComponent as VectorIcon } from '../assets/images/vector.svg';

import { PrivateRoute } from '../containers/PrivateRoute';
import { PublicRoute } from '../containers/PublicRoute';

import { Auth } from '../containers/Auth';
import { UserContainer } from '../containers';
import { visibleBySectionPermission } from './visibleBySectionPermission';
import { PERMISSIONS } from '../constants/variables';

export const serviceRoles = (id, permissions) => {
  let label;
  let privateRoute = <PrivateRoute component={UserContainer} />;
  const groupLink = [];
  const baseMailingPermissions = [
    PERMISSIONS.MAILING.ListMailingTemplates.value,
    PERMISSIONS.MAILING.RetrieveMailingTemplates.value,
    PERMISSIONS.MAILING.CreateMailingTemplates.value,
    PERMISSIONS.MAILING.UpdateMailingTemplates.value,
    PERMISSIONS.MAILING.ArchiveMailingTemplates.value,
    PERMISSIONS.MAILING.DeleteMailingTemplates.value,
  ];

  switch (id) {
    case rolesID.ROLE_ADMINISTRATOR:
      label = 'Администратор';
      break;

    case rolesID.ROLE_CONTENT_MANAGER:
      label = 'Контент-менеджер';
      break;

    case rolesID.ROLE_BONUS_MANAGER:
      label = 'Бонус-Менеджер';
      break;

    case rolesID.ROLE_MANAGER_SUPPORT:
      label = 'Менеджер технической поддержки';
      break;

    case rolesID.ROLE_SUPERVISER_TP:
      label = 'Финансовый контролер';
      break;

    default:
      label = undefined;
      privateRoute = <PublicRoute path={['/auth*']} exact={true} component={Auth} />;
      return {
        privateRoute,
        firstPage: ROUTES.LOGIN,
        label
      }
  }

  if (visibleBySectionPermission(permissions, [
    PERMISSIONS.PARTNERS.listPartners.value,
    PERMISSIONS.PARTNERS.createPartners.value,
    PERMISSIONS.PARTNER.listPartnerPromotions.value,
    PERMISSIONS.PARTNER.createPartnerPromotions.value
  ], 'or'))
    groupLink.push({ label: 'Партнёры', to: ROUTES.PARTNERS, icon: PartnersIcon });

  if (
    visibleBySectionPermission(permissions, [PERMISSIONS.BONUS.ListBonusCards.value, PERMISSIONS.BONUS.CreateBonusCards.value], 'or')
  )
    groupLink.push({ label: 'Бонусы', to: ROUTES.BONUSES, icon: BonusesIcon });
  
  groupLink.push({ label: 'Акции компании', to: ROUTES.COMPANY_PROMOTIONS, icon: BonusesIcon });
  
  if (visibleBySectionPermission(permissions, PERMISSIONS.DEDUCTION.ListDeductionBonusTransactions.value)) {
    groupLink.push({ label: 'Учет бонусов', to: ROUTES.BONUS_RECORD, icon: VectorIcon });
  }

  if (
    visibleBySectionPermission(permissions, [PERMISSIONS.USER.ListUsers.value, PERMISSIONS.USER.InviteUsers.value], 'or')
  )
    groupLink.push({ label: 'Команда', to: ROUTES.TEAM, icon: TeamIcon });

  if (visibleBySectionPermission(permissions,[PERMISSIONS.SUPPORT.RetrieveCustomer.value, PERMISSIONS.SUPPORT.ListSupportBonusRequests.value]))
    groupLink.push({ label: 'Техподдержка', to: ROUTES.SUPPORT, icon: SupportIcon });

  if (id === rolesID.ROLE_ADMINISTRATOR) groupLink.push({ label: 'Настройка прав', to: ROUTES.USER_PERMISSIONS, icon: SettingIcon });

  if (visibleBySectionPermission(permissions, baseMailingPermissions, 'or')) {
    groupLink.push({ label: 'СМС/Email рассылка', to: ROUTES.MAILING, icon: MailingIcon });
  }

  groupLink.forEach((link, index) => link.id = index + 1);

  return {
    groupLink,
    privateRoute,
    firstPage: ROUTES.START,
    label,
  };
};
